/**
 * Plain mock check payloads for PAT test mode.
 * Kept import-free so Playwright e2e tests can reuse this file without loading Angular.
 * Keep in sync with pat-mock-check.fixture.ts typing.
 */
export const PAT_DEFAULT_MOCK_CHECK_DATA = {
  id: 'mock-check-id',
  currency: 'CHF',
  final_price: 4800,
  outstanding_amount: 3200,
  opened_at: '2026-01-01T12:00:00Z',
  closed_at: '',
  items: [
    {
      id: 'item-1',
      name: 'Burger',
      price: 3200,
      description: 'Classic burger with fries',
      selected_by: { user: '', transaction: '' },
    },
    {
      id: 'item-2',
      name: 'Salade César',
      price: 1600,
      description: 'Fresh seasonal salad',
      selected_by: { user: '', transaction: '' },
    },
  ],
  transactions: [
    {
      id: 'txn-partial-1',
      status: 'CAPTURED',
      amount: 1600,
      paid_amount: 1600,
      source: 'dood',
      type: 'payment',
      cancellation_reason: '',
      user: 'mock-user',
      created_at: '2026-01-01T12:15:00Z',
      confirmed_at: '2026-01-01T12:15:30Z',
      payment_intent_id: '',
    },
    {
      id: 'test',
      status: 'CAPTURED',
      amount: 3200,
      paid_amount: 3200,
      source: 'dood',
      type: 'payment',
      cancellation_reason: '',
      user: 'mock-user',
      created_at: '2026-01-01T12:30:00Z',
      confirmed_at: null,
      payment_intent_id: '',
    },
  ],
  shop: {
    id: 'shop-mock-1',
    name: 'Test Shop',
    current_user_roles: [],
  },
  marketplace: {
    id: 'mp-mock-1',
    name: 'Test Marketplace',
    current_user_roles: [],
  },
  onsite_location: {
    id: 'table-mock-1',
    name: 'Table 5',
  },
  available_payment_methods: [
    {
      valid: true,
      violations: [],
      payment_method: { handle: 'STRIPE', position: 0 },
    },
    {
      valid: true,
      violations: [],
      payment_method: { handle: 'STRIPE_TWINT', position: 1 },
    },
  ],
} as const;

/** Variant for testing payment-refused confirmation screen. */
export const PAT_MOCK_CHECK_CANCELLED_DATA = {
  ...PAT_DEFAULT_MOCK_CHECK_DATA,
  transactions: [
    {
      id: 'test',
      status: 'CANCELLED',
      amount: 3200,
      paid_amount: 0,
      source: 'dood',
      type: 'payment',
      cancellation_reason: '',
      user: 'mock-user',
      created_at: '2026-01-01T12:30:00Z',
      confirmed_at: null,
      payment_intent_id: '',
    },
  ],
} as const;
